import { DashboardService } from '../../../../../service/events/dashboard.service';
import { AfterViewInit, ChangeDetectorRef, Component, NgZone, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormCommonApiService } from '../../../../../service/api/formcommon-api.service';
import { BaseForm } from '../../../../base-form';
import { FincasApiService } from '../../../../../service/api/fincas-api.service';
import { StorageManager } from '../../../../../common/storage-manager.class';
import { environment } from '../../../../../../environments/environment';
import { MapaParcelasApiService } from '../../../../../service/api/mapa-parcelas-api.service';
import { VisitasVariedadMesApiService } from '../../../../../service/api/visitas_variedad_mes-api.service';
import { DialogSigPacComponent } from './dialog/dialog.sigpac.component';
import { VentasApiService } from '../../../../../service/api/ventas-api.service';
import { SiexApiService } from '../../../../../service/api/siex-api.service';
import { UsuariosApiService } from '../../../../../service/api/usuarios-api.service';
import { ParcelasFormDefinition } from './form-definition';
import { AnalisisApiService } from '../../../../../service/api/analisis-api.service';
import { configureParcelasDeclarativeDropdowns } from './parcelas-declarative-dropdowns.config';
import { ParcelasDropdownDataSourceFactory } from './parcelas-dropdown-datasource.factory';
import { BrowserDiagnosticsService } from 'src/app/common/diagnostics/browser-diagnostics.service';
import type { DiagnosticMetric, DiagnosticSupportDataThresholdInput } from 'src/app/common/diagnostics/diagnostic-types';


import { ParcelasModel } from 'src/app/models/form-common/parcelas.model';
import { FullMapModel } from 'src/app/models/form-common/full-map.model';
import { MantenimientoModel } from 'src/app/models/trabajadores/mantenimiento.model';
import { ParcelasEnvironmentDefinition } from '../environment-variables';
import { HttpClient } from '@angular/common/http';
import { FormPhase, ReactiveFormRequestCoordinator } from '@fitogest/reactive-form-builder/form-request';
import { VisitasVariedadMesModel } from 'src/app/models/visitas_variedad_mes/visitas_variedad_mes.model';
import { TrabajadoresApiService } from 'src/app/service/api/trabajadores-api.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {
    ReactiveFormChangedField,
    ReactiveFormLifecycleEvent,
    ReactiveFormStableValueChange,
    ReactiveFormValue,
    DropdownData,
    FormType,
    type ReactiveFormSupportDataMetricsEvent,
} from '@fitogest/reactive-form-builder/interfaces';
import { ParcelasCatalogHydrator } from './parcelas-catalog-hydrator';
import { ParcelasStableFormChangeAdapter } from './parcelas-stable-form-change.adapter';
import { ParcelasReaReviewAdapter } from './parcelas-rea-review.adapter';
import { ParcelasSupportDataSourcesFactory } from './parcelas-support-data-sources.factory';
import { ParcelasFormFacade } from './parcelas-form.facade';
import {
    PARCELAS_FORM_SUPPORT_DATA_KEYS,
    type ParcelasFormSupportDataKey,
} from './parcelas-form-load-plan';
import {
    ReactiveFormLoadSession,
    ReactiveFormSupportDataReadinessPresenter,
    getDropdownSelectedArray,
    getDropdownSelectedSingle,
    setDropdownSelected,
    setDropdownSelectedFromArray,
    type ReactiveFormLoadPlan,
    type ReactiveFormLoadReadinessSnapshot,
    type ReactiveFormLoadSessionEvent,
    type ReactiveFormLoadStateSnapshot,
    type ReactiveFormSupportDataReadinessViewModel,
} from '@fitogest/reactive-form-builder/utils';
import type {
    ReactiveFormSupportDataReadinessItem,
    ReactiveFormSupportDataReadinessSeverity,
} from '@fitogest/reactive-form-builder/components';
import {
    type ParcelasVariedadVariosCreateRequest
} from './parcelas-variedad-varios.adapter';

type ParcelasSupportDataReadinessItem = ReactiveFormSupportDataReadinessItem;

const PARCELAS_SUPPORT_DATA_METRICS_LIMIT = 200;
const PARCELAS_SUPPORT_DATA_DIAGNOSTIC_GROUP = 'support-data';

const PARCELAS_SUPPORT_DATA_LABELS: Record<ParcelasFormSupportDataKey, string> = {
    [PARCELAS_FORM_SUPPORT_DATA_KEYS.patronVina]: 'Patrón',
    [PARCELAS_FORM_SUPPORT_DATA_KEYS.sistemasRiego]: 'Sistemas de riego',
    [PARCELAS_FORM_SUPPORT_DATA_KEYS.comunidadesRegantes]: 'Comunidades de regantes',
    [PARCELAS_FORM_SUPPORT_DATA_KEYS.origenesAguaRiego]: 'Orígenes de agua de riego',
    [PARCELAS_FORM_SUPPORT_DATA_KEYS.fincas]: 'Fincas',
    [PARCELAS_FORM_SUPPORT_DATA_KEYS.sectores]: 'Sectores',
    [PARCELAS_FORM_SUPPORT_DATA_KEYS.compradores]: 'Compradores',
    [PARCELAS_FORM_SUPPORT_DATA_KEYS.aplicadores]: 'Aplicadores',
    [PARCELAS_FORM_SUPPORT_DATA_KEYS.usuarios]: 'Usuarios',
    [PARCELAS_FORM_SUPPORT_DATA_KEYS.legacyCultivos]: 'Cultivos propios',
    [PARCELAS_FORM_SUPPORT_DATA_KEYS.legacyVariedades]: 'Variedades propias',
};

@Component({
    selector: 'app-parcelas-form',
    standalone: false,
    templateUrl: './parcelas-form.component.html',
    styleUrls: ['./parcelas-form.component.scss']
})
export class ParcelasFormComponent extends BaseForm<ParcelasModel> implements AfterViewInit, OnInit {

    @ViewChild('sigpac', { read: DialogSigPacComponent, static: true }) sigpacDialog: DialogSigPacComponent | undefined;

    public form!: ParcelasFormDefinition;

    public formRequest = new ReactiveFormRequestCoordinator<ParcelasModel>;

    public readonly reactiveFormLoadingLabel = 'Preparando formulario de parcelas...';

    public loadingData = true;

    public shouldRenderMapDialog = false;

    public isReactiveFormReady = false;

    public reactiveFormLoadingError = '';

    public reactiveFormLoadPlan: ReactiveFormLoadPlan | null = null;

    public reactiveFormLoadReadiness: ReactiveFormLoadReadinessSnapshot | null = null;

    public readonly parcelasSupportDataReadinessTitle = 'Datos complementarios de parcelas';

    public parcelasSupportDataReadinessSummary = '';

    public parcelasSupportDataReadinessSeverity: ReactiveFormSupportDataReadinessSeverity = 'info';

    public parcelasSupportDataReadinessItems: ParcelasSupportDataReadinessItem[] = [];

    public parcelasSupportDataMetrics: ReactiveFormSupportDataMetricsEvent[] = [];

    public getRequest = this.fincasApi.parcelasGET;

    public initialPreviousData: ParcelasModel | null = null;

    public reactiveFormRecordId = '';

    public override model: ParcelasModel = {
        activo: '1',
        turbo: '1',
        mapa: [{} as FullMapModel]
    } as ParcelasModel;

    public mapaAux = {} as FullMapModel;

    public variedadVariosCreated = false;

    public env: ParcelasEnvironmentDefinition = new ParcelasEnvironmentDefinition();



    public origin = 'parcelas-form';

    public viewNumeroMetros = false;

    public nombreTouched = false;

    public comunidadForm: FormGroup;

    private pendingReaReviewFincaId = '';
    private externalDropdownsLoaded = false;
    private reactiveFormLoadSession: ReactiveFormLoadSession<ParcelasModel> | null = null;
    private parcelasFormFacade: ParcelasFormFacade | null = null;

    constructor(
        public override route: ActivatedRoute,
        public override router: Router,
        public formApi: FormCommonApiService,
        public fincasApi: FincasApiService,
        public mapaParcelasApi: MapaParcelasApiService,
        public override dashboard: DashboardService,
        public visitasVariedadMesApi: VisitasVariedadMesApiService,
        private readonly ventasApi: VentasApiService,
        public siexApi: SiexApiService,
        public analisisApi: AnalisisApiService,
        public usuariosAPI: UsuariosApiService,
        public trabajadoresApi: TrabajadoresApiService,
        private readonly zone: NgZone,
        private readonly http: HttpClient,
        private readonly formBuilder: FormBuilder,
        private readonly cdr: ChangeDetectorRef,
        private readonly dropdownDataSourceFactory: ParcelasDropdownDataSourceFactory,
        private readonly diagnostics: BrowserDiagnosticsService

    ) {
        super(
            route,
            router,
            dashboard,
            fincasApi.parcelasPUT,
            fincasApi.parcelasPOST,
            'parcelas',
            'Editar ' + environment.features.parcelaName,
            'Crear ' + environment.features.parcelaName
        );
        this.comunidadForm = this.formBuilder.group({
            nombre: ['', [Validators.required, Validators.maxLength(100)]],
            id_usuario: [StorageManager.getUser().id],
            id_cliente: [StorageManager.getClient()?.id ?? ''],
        });
    }


    ngAfterViewInit(): void {
        if (this.externalDropdownsLoaded) {
            this.finalizeExternalDropdownsOnly();
        }
    }

    public async ngOnInit(): Promise<void> {
        await this.initializeParcelasForm();
    }

    private async initializeParcelasForm(): Promise<void> {
        try {
            this.loadingData = true;
            this.isReactiveFormReady = false;
            this.reactiveFormLoadingError = '';
            this.reactiveFormLoadPlan = null;
            this.reactiveFormLoadReadiness = null;
            this.reactiveFormLoadSession = null;
            this.externalDropdownsLoaded = false;
            this.refreshParcelasSupportDataReadiness();
            this.resetExternalDropdowns();
            this.fincasApi.parcelasPOST.reset();
            this.fincasApi.parcelasPUT.reset();
            this.applyInitialRouteState();
            this.softInit(this.getType());
            this.reactiveFormRecordId = this.resolveReactiveFormRecordId(this.model);
            this.initializeHostModel(this.model);
            this.initialPreviousData = this.getInitialPreviousData();
            this.form = new ParcelasFormDefinition(
                this.getType(),
                this.model as unknown as Record<string, string>,
                this.sigpacDialog as DialogSigPacComponent,
                null
            );
            this.form.model = this.toParcelasModel(this.model);
            this.form.formFields.previousDataTransform = (previousData) => this.transformCatalogPreviousData(previousData);
            this.configureDeclarativeDropdownSources();
            this.expandFormRequest();
            await this.runParcelasFormLoadSession();
        } catch (error: unknown) {
            this.loadingData = false;
            this.hostController.setLoadBlockingErrors(true);
            this.finalizeExternalDropdowns();
            this.applyParcelasLoadState(this.reactiveFormLoadSession?.state.snapshot() ?? null);
            this.reactiveFormLoadingError = this.getReadableInitialisationError(error);
            this.cdr.markForCheck();
            console.error('No se ha podido preparar el formulario de parcelas.', error);
        }
    }

    private applyInitialRouteState(): void {
        const reaReviewState = ParcelasReaReviewAdapter.buildInitialState({
            queryParamMap: this.route.snapshot.queryParamMap,
        });
        this.pendingReaReviewFincaId = reaReviewState.pendingFincaId;

        if (reaReviewState.modelPatch !== null) {
            this.model = this.toParcelasModel({
                ...this.model,
                ...reaReviewState.modelPatch,
                mapa: this.model.mapa ?? [{} as FullMapModel]
            });
        }

        if (this.pendingReaReviewFincaId !== '') {
            this.model = this.toParcelasModel({
                ...this.model,
                id_finca: this.pendingReaReviewFincaId,
            });
        }
    }

    public async afterSend(res: unknown): Promise<void> {
        await this.getParcelasFormFacade().afterSend({
            backendResponse: res,
            currentMap: this.form.model.mapa?.[0] as FullMapModel | null | undefined,
            env: this.env,
            userId: StorageManager.getUser().id,
            customMapColors: this.env.customMapColorsList,
            variedadVariosCreated: this.variedadVariosCreated,
            loadExistingMaps: () => this.mapaParcelasApi.mapaParcelasGET.toPromise() as Promise<
                readonly FullMapModel[] | null | undefined
            >,
            updateMap: (map) => this.mapaParcelasApi.mapaParcelasPUT.toPromise(map),
            createMap: (map) => this.mapaParcelasApi.mapaParcelasPOST.toPromise(map),
            setAuxMap: (map) => {
                this.mapaAux = map;
            },
            reloadPage: () => {
                window.location.reload();
            },
            goBack: () => {
                this.goBack();
            },
            logError: (message, error) => {
                console.error(message, error);
            },
        });
    }

    public handleMapDialogShown(): void {
        this.shouldRenderMapDialog = true;
        this.scrollToTop();
    }

    public getSigPac(event: object): void {
        this.getParcelasFormFacade().applySigpacReference({
            event,
            applyModelPatch: (patch) => {
                Object.assign(this.form.model, patch);
            },
            updateReactiveForm: () => {
                this.formBuilderRef.updateForm(this.form.model, false);
            },
        });
    }

    public reloadComponent(): void {
        this.getParcelasFormFacade().reloadComponent({
            closeMap: () => {
                this.form.mapaOpened = false;
            },
            reloadPage: () => {
                window.location.reload();
            },
        });
    }


    public stableValueChanges(event: ReactiveFormStableValueChange<ParcelasModel>): void {
        this.form.model = this.toParcelasModel({
            ...this.form.model,
            ...event.value,
        });
        this.form.tag = event.changedField;
        this.syncModelFromForm();

        if (event.origin !== 'user') {
            return;
        }

        this.handleFormValueChange(event.value, event.changedField);
    }

    public onReactiveFormLifecycleEvent(event: ReactiveFormLifecycleEvent<ParcelasModel>): void {
        if (event.type !== 'previousDataPatched' && event.type !== 'previousDataChanged') {
            return;
        }

        this.form.model = this.toParcelasModel({
            ...this.form.model,
            ...event.value,
        });
        this.syncModelFromForm();
    }

    public handleFormValueChange(
        formModel: ReactiveFormValue<ParcelasModel>,
        lastChangedFieldName: ReactiveFormChangedField<ParcelasModel>,
    ): void {
        this.applyStableFormChange(formModel, lastChangedFieldName);
    }

    private applyStableFormChange(
        formModel: ReactiveFormValue<ParcelasModel>,
        lastChangedFieldName: ReactiveFormChangedField<ParcelasModel>,
    ): void {
        const result = ParcelasStableFormChangeAdapter.resolveChange({
            formModel,
            changedField: lastChangedFieldName,
            env: this.env,
            client: StorageManager.getClient(),
            resolveDropdownRawValue: (fieldName, value) => this.formBuilderRef?.resolveDropdownRawValue(fieldName, value) ?? null,
        });

        this.form.model = this.toParcelasModel(result.formModel);
        this.form.tag = result.tag;
        this.syncModelFromForm();

        if (result.markNombreTouched) {
            this.nombreTouched = true;
        }
    }


    public get reaReviewNotice(): string {
        return ParcelasReaReviewAdapter.getNotice({
            queryParamMap: this.route.snapshot.queryParamMap,
            formModel: this.form?.model,
            fallbackModel: this.model,
        });
    }

    public getFromMapa(datos: string): void {
        this.zone.run(() => {
            const nombreControl = this.formBuilderRef.model.get('nombre');

            this.getParcelasFormFacade().applyIncomingMapData({
                rawData: datos,
                currentMap: this.form.model.mapa?.[0] ?? null,
                currentMaps: this.form.model.mapa ?? [],
                env: this.env,
                userId: StorageManager.getUser().id,
                shouldUpdateName: Boolean(nombreControl && (nombreControl.pristine || !nombreControl.value)),
                applyModelPatch: (patch) => {
                    Object.assign(this.form.model, patch);
                },
                setMaps: (maps) => {
                    this.form.model.mapa = [...maps];
                },
                setSuggestedName: (name) => {
                    this.form.model.nombre = name;
                },
                closeMap: () => {
                    this.form.mapaAbierto = false;
                },
                updateReactiveForm: () => {
                    this.formBuilderRef.updateForm(this.form.model, false);
                },
                markNombrePristine: () => {
                    this.formBuilderRef.model.get('nombre')?.markAsPristine();
                },
            });
        });
    }





    public getMapColor(mapa: FullMapModel): FullMapModel {
        return this.getParcelasFormFacade().withMapColor(mapa, this.env.customMapColorsList);
    }

    public saveNewOption(): void {
        this.getParcelasFormFacade().saveComunidadRegantes({
            comunidadForm: this.comunidadForm,
            endpoint: `${this.env.serverURL}/ws/index.php?p1=generic&p2=comunidades_regantes`,
            http: this.http,
            reloadRequest: this.analisisApi.comunidadesRegantes.GET,
            comunidadesRegantesDropdown: this.form.lists.comunidadesRegantes,
            closeDialog: () => {
                this.form.openDialog = false;
            },
        });
    }



    private getParcelasFormFacade(): ParcelasFormFacade {
        this.parcelasFormFacade ??= new ParcelasFormFacade({
            dataSourceFactory: this.dropdownDataSourceFactory,
            getFormBuilderRef: () => this.formBuilderRef,
            getFormModel: () => this.form?.model,
            getFallbackModel: () => this.model,
            getLegacyCultivoSelected: () => this.form?.lists?.cultivos
                ? getDropdownSelectedSingle(this.form.lists.cultivos)
                : null,
            getLegacyVariedadSelected: () => this.form?.lists?.variedades
                ? getDropdownSelectedSingle(this.form.lists.variedades)
                : null,
            getFormType: () => this.getType(),
            getUserId: () => StorageManager.getUser().id,
            getClientId: () => StorageManager.getClient()?.id ?? '',
            refreshReactiveDropdownMappings: () => this.refreshReactiveDropdownMappings(),
        });

        return this.parcelasFormFacade;
    }

    /**
     * Applies the REA finca selection after dropdown data has been loaded.
     */
    private applyReaReviewFincaSelection(): void {
        const fincaDropdown = this.form.lists.fincas as DropdownData<unknown>;
        const control = this.formBuilderRef?.model?.get('id_finca');

        this.getParcelasFormFacade().synchronizeReaFincaSelection({
            pendingFincaId: this.pendingReaReviewFincaId,
            fincaDropdown,
            hasCurrentMap: Boolean(this.form.model.mapa?.[0]),
            applyModelPatch: (patch) => {
                Object.assign(this.model, patch);
            },
            applyFormModelPatch: (patch) => {
                Object.assign(this.form.model, patch);
            },
            setSelectedFinca: (selectedFinca) => {
                setDropdownSelected(fincaDropdown, selectedFinca);
            },
            patchFincaControl: (fincaId) => {
                control?.patchValue(fincaId, { emitEvent: false });
            },
            markFincaControlPristine: () => {
                control?.markAsPristine();
            },
            applyMapPatch: (patch) => {
                Object.assign(this.form.model.mapa?.[0] ?? {}, patch);
            },
            updateReactiveForm: () => {
                this.formBuilderRef?.updateForm(this.form.model, false);
            },
        });
    }

    private toStringId(value: unknown): string {
        return this.dropdownDataSourceFactory.toStringId(value);
    }


    private configureDeclarativeDropdownSources(): void {
        configureParcelasDeclarativeDropdowns({
            form: this.form,
            formType: this.getType(),
            env: this.env,
            dataSources: this.dropdownDataSourceFactory.createDataSources({
                env: this.env,
                addDefaultAplicador: (row) => this.addDefaultSequiadorAplicador(row),
            }),
        });

        this.form.formFields.supportDataSources = ParcelasSupportDataSourcesFactory.create({
            form: this.form,
            formType: this.getType(),
            env: this.env,
            endpoints: {
                portainjertosGET: this.siexApi.portainjertosGET,
                sistemasRiegoGET: this.siexApi.sistemasRiegoGET,
                comunidadesRegantesGET: this.analisisApi.comunidadesRegantes.GET,
                origenesAguaRiegoGET: this.siexApi.origenesAguaRiegoGET,
                fincasGET: this.fincasApi.fincasGET,
                sectoresGET: this.fincasApi.sectoresGET,
                compradoresGET: this.ventasApi.compradoresGET,
                usuariosGET: this.usuariosAPI.usuariosGET,
                trabajadoresGET: this.trabajadoresApi.trabajadoresGET,
                cultivosGET: this.formApi.cultivosGET,
                variedadesGET: this.formApi.variedadesGET,
            },
            addDefaultSequiadorAplicador: (row) => this.addDefaultSequiadorAplicador(row),
        });
    }
    private toRecord(value: unknown): Record<string, unknown> {
        return this.dropdownDataSourceFactory.toRecord(value);
    }

    private addDefaultSequiadorAplicador(row: unknown): void {
        const rowRecord = this.toRecord(row);

        if (this.toStringId(rowRecord['nombre']) !== 'TONI') {
            return;
        }

        const selectedList = getDropdownSelectedArray<MantenimientoModel>(this.form.lists.aplicadores);
        const rowId = this.toStringId(rowRecord['id']);
        const alreadySelected = selectedList.some((item) => this.toStringId(this.toRecord(item)['id']) === rowId);

        if (!alreadySelected) {
            selectedList.push(row as MantenimientoModel);
            setDropdownSelectedFromArray(
                this.form.lists.aplicadores,
                selectedList,
                true
            );
        }
    }

    private transformCatalogPreviousData(previousData: ParcelasModel): ParcelasModel {
        return ParcelasCatalogHydrator.transformPreviousData({
            previousData,
            env: this.env,
            formType: this.getType(),
            cultivosDropdown: this.form.lists.cultivos as DropdownData<unknown>,
            variedadesDropdown: this.form.lists.variedades as DropdownData<unknown>,
            sectoresDropdown: this.form.lists.sectores as DropdownData<unknown>,
            sistemasRiegoDropdown: this.form.lists.sistemasRiego as DropdownData<unknown>,
            usuariosDropdown: this.form.lists.usuarios as DropdownData<unknown>,
            aplicadoresDropdown: this.form.lists.aplicadores as DropdownData<unknown>,
            comunidadesRegantesDropdown: this.form.lists.comunidadesRegantes as DropdownData<unknown>,
            origenesAguaRiegoDropdown: this.form.lists.origenesAguaRiego as DropdownData<unknown>,
            dataSourceFactory: this.dropdownDataSourceFactory,
        });
    }

    private async runParcelasFormLoadSession(): Promise<void> {
        const loadSession = new ReactiveFormLoadSession<ParcelasModel>({
            form: this.form.formFields,
            previousData: this.initialPreviousData,
            render: () => this.renderParcelasReactiveForm(),
            refreshDropdownMappings: () => this.finalizeExternalDropdownsOnly(),
            onEvent: (event) => this.handleParcelasLoadSessionEvent(event),
        });

        this.reactiveFormLoadSession = loadSession;
        await loadSession.start();

        const loadState = loadSession.state.snapshot();

        if (!loadState.renderReady) {
            throw new Error('No se han podido cargar los catálogos iniciales de parcelas.');
        }

        this.applyParcelasLoadState(loadState);
    }

    private async renderParcelasReactiveForm(): Promise<void> {
        this.applyReaReviewFincaSelection();
        await this.formRequest.executePhase(FormPhase.LOAD);
        this.loadingData = false;
        this.markReactiveFormReady();
    }

    private handleParcelasLoadSessionEvent(event: ReactiveFormLoadSessionEvent): void {
        const loadState = this.reactiveFormLoadSession?.state.snapshot() ?? null;

        if (event.type === 'supportDataMetrics' && event.supportDataMetrics !== undefined) {
            this.recordParcelasSupportDataMetric(event.supportDataMetrics);
        }

        this.applyParcelasLoadState(loadState);

        if (event.type === 'phaseFailed' && event.phase === 'deferred') {
            console.error('No se han podido completar los datos diferidos de parcelas.', event.error ?? null);
        }
    }

    private recordParcelasSupportDataMetric(metric: ReactiveFormSupportDataMetricsEvent): void {
        this.parcelasSupportDataMetrics = [...this.parcelasSupportDataMetrics, metric].slice(-PARCELAS_SUPPORT_DATA_METRICS_LIMIT);
        this.recordParcelasSupportDataDiagnostic(metric);

        if (!metric.ok) {
            console.warn('Error loading Parcelas support data source.', metric);
        }
    }

    private recordParcelasSupportDataDiagnostic(metric: ReactiveFormSupportDataMetricsEvent): void {
        const diagnosticsMetrics = this.createParcelasSupportDataDiagnosticMetrics(metric);
        const sourceLabel = PARCELAS_SUPPORT_DATA_LABELS[metric.sourceKey as ParcelasFormSupportDataKey] ?? metric.sourceKey;

        this.registerParcelasSupportDataDiagnosticsThreshold(metric);

        this.diagnostics.record({
            name: metric.sourceKey,
            group: PARCELAS_SUPPORT_DATA_DIAGNOSTIC_GROUP,
            durationMs: metric.phaseMs,
            metadata: {
                formName: metric.formName ?? 'parcelas',
                sourceKey: metric.sourceKey,
                sourceLabel,
                phase: metric.phase,
                trigger: metric.trigger,
                cacheStatus: metric.cacheStatus,
                cacheHit: metric.cacheHit,
                staleHit: metric.staleHit,
                sourceKind: metric.sourceKind,
            },
            metrics: diagnosticsMetrics,
            ...(metric.error !== undefined ? { error: metric.error } : {}),
        });
    }

    private registerParcelasSupportDataDiagnosticsThreshold(metric: ReactiveFormSupportDataMetricsEvent): void {
        if (metric.diagnosticsThreshold === undefined) {
            return;
        }

        const threshold: DiagnosticSupportDataThresholdInput = {
            formName: metric.formName ?? 'parcelas',
            sourceKey: metric.sourceKey,
            ...(metric.phase === 'all' ? {} : { phase: metric.phase }),
            ...metric.diagnosticsThreshold,
        };

        this.diagnostics.registerSupportDataThresholds([threshold]);
    }

    private createParcelasSupportDataDiagnosticMetrics(metric: ReactiveFormSupportDataMetricsEvent): DiagnosticMetric[] {
        const diagnosticsMetrics: DiagnosticMetric[] = [
            { name: 'phaseMs', value: metric.phaseMs, unit: 'ms' },
            { name: 'cacheHit', value: metric.cacheHit ? 1 : 0, unit: 'count' },
            { name: 'staleHit', value: metric.staleHit ? 1 : 0, unit: 'count' },
        ];

        if (metric.networkMs !== null) {
            diagnosticsMetrics.push({ name: 'networkMs', value: metric.networkMs, unit: 'ms' });
        }

        return diagnosticsMetrics;
    }

    private applyParcelasLoadState(loadState: ReactiveFormLoadStateSnapshot | null): void {
        this.reactiveFormLoadPlan = loadState?.plan ?? this.reactiveFormLoadPlan;
        this.reactiveFormLoadReadiness = loadState?.readiness ?? null;
        this.applyParcelasSupportDataReadinessViewModel(this.createParcelasSupportDataReadinessViewModel(loadState));
        this.cdr.markForCheck();
    }

    private refreshParcelasSupportDataReadiness(): void {
        const loadState = this.reactiveFormLoadSession?.state.snapshot() ?? null;

        this.applyParcelasSupportDataReadinessViewModel(this.createParcelasSupportDataReadinessViewModel(loadState));
    }

    private createParcelasSupportDataReadinessViewModel(
        loadState: ReactiveFormLoadStateSnapshot | null,
    ): ReactiveFormSupportDataReadinessViewModel {
        return ReactiveFormSupportDataReadinessPresenter.createViewModel({
            sources: this.form?.formFields.supportDataSources ?? [],
            labels: PARCELAS_SUPPORT_DATA_LABELS,
            loadState,
        });
    }

    private applyParcelasSupportDataReadinessViewModel(viewModel: ReactiveFormSupportDataReadinessViewModel): void {
        this.parcelasSupportDataReadinessItems = [...viewModel.items];
        this.parcelasSupportDataReadinessSeverity = viewModel.severity;
        this.parcelasSupportDataReadinessSummary = viewModel.summary;
    }

    private refreshReactiveDropdownMappings(): void {
        this.externalDropdownsLoaded = true;
        this.formBuilderRef?.finalizeExternalDropdowns();
        this.formBuilderRef?.requestExternalDropdownMappingsRefresh();
    }

    private finalizeExternalDropdownsOnly(): void {
        this.externalDropdownsLoaded = true;
        this.hostController.state.finalizeExternalDropdowns();
        this.formBuilderRef?.finalizeExternalDropdowns();
        this.applyParcelasLoadState(this.reactiveFormLoadSession?.state.snapshot() ?? null);
    }

    private markReactiveFormReady(): void {
        this.isReactiveFormReady = true;
        this.markFormReady();
        this.markRepeatablesReady();
        this.cdr.detectChanges();
        this.finalizeExternalDropdownsOnly();
        this.cdr.markForCheck();
    }

    private getInitialPreviousData(): ParcelasModel | null {
        if (this.getType() !== FormType.DUPLICATION) {
            return null;
        }

        return this.toParcelasModel(this.model);
    }

    private getReadableInitialisationError(error: unknown): string {
        if (error instanceof Error && error.message.trim() !== '') {
            return 'No se ha podido cargar el formulario de parcelas: ' + error.message;
        }

        return 'No se ha podido cargar el formulario de parcelas. Revisa la conexión e inténtalo de nuevo.';
    }

    private syncModelFromForm(): void {
        const normalizedModel = this.toParcelasModel(this.form.model);

        this.form.model = normalizedModel;
        this.updateHostModel(normalizedModel);
    }

    private toParcelasModel(
        sourceModel: ReactiveFormValue<ParcelasModel> | Partial<ParcelasModel> | Record<string, unknown>,
    ): ParcelasModel {
        const normalizedModel: Record<string, ParcelasModel[keyof ParcelasModel]> = {};

        for (const [key, value] of Object.entries(sourceModel)) {
            if (value !== undefined) {
                normalizedModel[key] = value as ParcelasModel[keyof ParcelasModel];
            }
        }

        if (!Array.isArray(normalizedModel['mapa'])) {
            normalizedModel['mapa'] = [{} as FullMapModel] as ParcelasModel[keyof ParcelasModel];
        }

        return normalizedModel as ParcelasModel;
    }


    private createVariedadVarios(
        request: ParcelasVariedadVariosCreateRequest
    ): Promise<readonly Partial<VisitasVariedadMesModel>[] | null | undefined> {
        return this.visitasVariedadMesApi.visitasVariedadMes.POST.toPromise(request as never) as Promise<
            readonly Partial<VisitasVariedadMesModel>[] | null | undefined
        >;
    }

    private expandFormRequest(): void {
        this.getParcelasFormFacade().registerSendBefore({
            formRequest: this.formRequest,
            env: this.env,
            formFieldsDatosParcela: this.form.formFieldsDatosParcela.fields,
            variedadesDropdown: this.form.lists.variedades as DropdownData<VisitasVariedadMesModel>,
            createVariedad: (request) => this.createVariedadVarios(request),
            applyLegacyModelPatch: (patch) => {
                if (patch.id_variedad !== undefined) {
                    this.model.id_variedad = patch.id_variedad;
                }
            },
            markVariedadVariosCreated: () => {
                this.variedadVariosCreated = true;
            },
            applyFormModelPatch: (patch) => {
                this.form.model = {
                    ...this.form.model,
                    ...patch,
                };
                this.formBuilderRef.updateForm(this.form.model, false);
            },
            logError: (message) => {
                console.log(message);
            },
        });
    }
}
